import { render, staticRenderFns } from "./UserCreatePage.vue?vue&type=template&id=6eeb636c&"
import script from "./UserCreatePage.vue?vue&type=script&lang=ts&"
export * from "./UserCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports